export default __webpack_public_path__ + "static/media/emergent-reader.1407b352.png";